// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BWCLink-module--wrapper--3UpFM","logo":"BWCLink-module--logo--3nP3n","flexcontainer":"BWCLink-module--flexcontainer--1eZbQ"};